/**
 * Lists all possible frequency values.
 */
export default [
  { key: 'celsius', value: 'ºC' },
  { key: 'fahrenheit', value: 'ºF' },
]
